import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-1fa43ed5"), n = n(), _popScopeId(), n);
const _hoisted_1 = { id: "live-container" };
const _hoisted_2 = { id: "live-top-container" };
const _hoisted_3 = { id: "live-left-container" };
const _hoisted_4 = {
    id: "mobile-server-name-count",
    class: "absolute text-center shadow full-width bottom exo-regular-small"
};
const _hoisted_5 = { id: "live-right-container" };
const _hoisted_6 = {
    key: 0,
    class: "umbra"
};
const _hoisted_7 = { id: "live-bottom-container" };
const _hoisted_8 = { class: "full-parent absolute" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_LiveUniverse = _resolveComponent("LiveUniverse");
    const _component_Mapbox = _resolveComponent("Mapbox");
    const _component_FlightCard = _resolveComponent("FlightCard");
    const _component_AirportCard = _resolveComponent("AirportCard");
    const _component_LoadingIndicator = _resolveComponent("LoadingIndicator");
    const _component_StateSvg = _resolveComponent("StateSvg");
    const _component_Tuple = _resolveComponent("Tuple");
    const _component_LiveOverlay = _resolveComponent("LiveOverlay");
    const _component_FullLiveOverlay = _resolveComponent("FullLiveOverlay");
    return (_openBlock(), _createElementBlock(_Fragment, null, [
        _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                    (_ctx.isUniverseActive)
                        ? (_openBlock(), _createBlock(_component_LiveUniverse, {
                            key: 0,
                            id: "live-universe",
                            flights: _ctx.currentFlights,
                            airports: _ctx.currentAirports,
                            currentFlight: _ctx.currentFlightDetail,
                            isTargetingFlight: _ctx.isTargetingFlight,
                            onOnClickMap: _ctx.onClickMap
                        }, null, 8, ["flights", "airports", "currentFlight", "isTargetingFlight", "onOnClickMap"]))
                        : _createCommentVNode("v-if", true),
                    (!_ctx.isUniverseActive)
                        ? (_openBlock(), _createBlock(_component_Mapbox, {
                            key: 1,
                            onOnClickEarth: _ctx.onClickEarth,
                            flights: _ctx.currentFlights,
                            airports: _ctx.currentAirports,
                            currentFlight: _ctx.currentFlightDetail,
                            isTargetingFlight: _ctx.isTargetingFlight
                        }, null, 8, ["onOnClickEarth", "flights", "airports", "currentFlight", "isTargetingFlight"]))
                        : _createCommentVNode("v-if", true),
                    _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.currentServerName) + " - " + _toDisplayString(_ctx.currentServerCounts), 1)
                ]),
                _createElementVNode("div", _hoisted_5, [
                    _createVNode(_Transition, { name: "card" }, {
                        default: _withCtx(() => [
                            (_ctx.isFlightCardOn && !_ctx.isCardLoading)
                                ? (_openBlock(), _createBlock(_component_FlightCard, {
                                    key: 0,
                                    onOnFullScreen: _ctx.onFlightFullScreen
                                }, null, 8, ["onOnFullScreen"]))
                                : _createCommentVNode("v-if", true)
                        ]),
                        _: 1
                    }),
                    _createVNode(_Transition, { name: "card" }, {
                        default: _withCtx(() => [
                            (!_ctx.isFlightCardOn && !_ctx.isCardLoading)
                                ? (_openBlock(), _createBlock(_component_AirportCard, {
                                    key: 0,
                                    onOnFullScreen: _ctx.onAirportFullScreen
                                }, null, 8, ["onOnFullScreen"]))
                                : _createCommentVNode("v-if", true)
                        ]),
                        _: 1
                    }),
                    _createVNode(_Transition, {
                        name: "loading-card",
                        class: "full-parent grid-center catch-events"
                    }, {
                        default: _withCtx(() => [
                            (_ctx.isCardLoading)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                                    (_ctx.isCardLoading)
                                        ? (_openBlock(), _createBlock(_component_LoadingIndicator, { key: 0 }))
                                        : _createCommentVNode("v-if", true)
                                ]))
                                : _createCommentVNode("v-if", true)
                        ]),
                        _: 1
                    })
                ])
            ]),
            _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", null, [
                    _createVNode(_component_StateSvg, {
                        src: "svg/charts.svg",
                        class: "live-action-icon",
                        onClick: _ctx.onClickChart
                    }, null, 8, ["onClick"])
                ]),
                _createElementVNode("div", null, [
                    _createVNode(_component_StateSvg, {
                        src: "svg/search.svg",
                        class: "live-action-icon",
                        onClick: _ctx.onClickSearch
                    }, null, 8, ["onClick"])
                ]),
                _createElementVNode("div", null, [
                    _createVNode(_component_StateSvg, {
                        src: "svg/server.svg",
                        class: "live-action-icon grid-center",
                        onClick: _ctx.onClickServer,
                        react: false
                    }, null, 8, ["onClick"]),
                    _createVNode(_component_Tuple, {
                        id: "live-bottom-server-name",
                        value: _ctx.currentServerName,
                        title: _ctx.currentServerCounts,
                        onClick: _ctx.onClickServer
                    }, null, 8, ["value", "title", "onClick"])
                ]),
                _createElementVNode("div", null, [
                    _createVNode(_component_StateSvg, {
                        src: "svg/traffic.svg",
                        class: "live-action-icon",
                        onClick: _ctx.onClickAirports
                    }, null, 8, ["onClick"])
                ]),
                _createElementVNode("div", null, [
                    _createVNode(_component_StateSvg, {
                        src: "svg/settings.svg",
                        class: "live-action-icon",
                        onClick: _ctx.onClickSettings
                    }, null, 8, ["onClick"])
                ])
            ])
        ]),
        _createElementVNode("div", _hoisted_8, [
            _createVNode(_Transition, { name: "live-overlay" }, {
                default: _withCtx(() => [
                    (_ctx.isVisibleOverlay)
                        ? (_openBlock(), _createBlock(_component_LiveOverlay, {
                            key: 0,
                            iconSrc: _ctx.overlayIconSrc,
                            title: _ctx.overlayTitle,
                            body: _ctx.overlayBody,
                            onOnClose: _cache[0] || (_cache[0] = ($event) => (_ctx.isVisibleOverlay = false))
                        }, null, 8, ["iconSrc", "title", "body"]))
                        : _createCommentVNode("v-if", true)
                ]),
                _: 1
            }),
            _createVNode(_Transition, { name: "live-overlay" }, {
                default: _withCtx(() => [
                    (_ctx.isVisibleFullOverlay)
                        ? (_openBlock(), _createBlock(_component_FullLiveOverlay, {
                            key: 0,
                            iconSrc: _ctx.overlayIconSrc,
                            title: _ctx.overlayTitle,
                            body: _ctx.overlayBody,
                            onOnClose: _cache[1] || (_cache[1] = ($event) => (_ctx.isVisibleFullOverlay = false))
                        }, null, 8, ["iconSrc", "title", "body"]))
                        : _createCommentVNode("v-if", true)
                ]),
                _: 1
            })
        ])
    ], 64));
}
